<template>
    <v-container class="my-5">
        <h2 class="subheading grey--text">{{$t('parcel')}}</h2>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('parcel')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            clearable
                            append-icon="mdi-magnify"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataDirectory"
                        :items="directorys"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip
                        label
                        :color="item.status === 0 ? 'warning' : 'success'"
                        dark
                    >
                      {{item.status === 0 ? $t('in_booth') : $t('delivered') }}
                    </v-chip>
                  </template>
                  <template v-slot:item.vigilant_name="{ item }">
                      {{item.vigilant_name === null ? 'n/a' : item.vigilant_name }}
                  </template>
                  <template v-slot:item.resident_name="{ item }">
                      {{item.resident_name === null ? 'n/a' : item.resident_name }}
                  </template>
                  <template v-slot:item.date_time_delivery="{ item }">
                      {{item.date_time_delivery === null ? 'n/a' : item.date_time_delivery }}
                  </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapState } from 'vuex'

export default {
  name: 'parcel',
  created () {
    this.getDirectory()
  },
  computed: {
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    number: '',
    nameAux: '',
    numberAux: '',
    header: [],
    loadingDataDirectory: false,
    loading: false,
    directorys: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: ''
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('company'),
        align: 'left',
        sortable: true,
        value: 'company_name'
      },
      {
        text: this.$t('guide_number'),
        align: 'left',
        sortable: true,
        value: 'tracking_number'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      },
      {
        text: this.$t('date_time_receipt'),
        align: 'left',
        sortable: true,
        value: 'date_time_receipt'
      },
      {
        text: this.$t('delivery_date_time'),
        align: 'left',
        sortable: true,
        value: 'date_time_delivery'
      },
      {
        text: this.$t('Vigilante'),
        align: 'left',
        sortable: true,
        value: 'vigilant_name'
      },
      {
        text: this.$t('residente'),
        align: 'left',
        sortable: true,
        value: 'resident_name'
      }
    ]
  },
  methods: {
    getDirectory () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/parcel_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.directorys = response.data
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    }
  }
}
</script>
